import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './hooks/useAuth'
import { authUtils } from './utils/authUtils'
import ProtectedRoute from './components/auth/ProtectedRoute'
import DashboardLayout from './components/layout/DashboardLayout'
import LoginPage from './pages/LoginPage'
import Dashboard from './pages/Dashboard'
import UsersPage from './pages/UsersPage'
import UserFormPage from './pages/UserFormPage'
import AulasPage from './pages/AulasPage'
import QuestoesPage from './pages/QuestoesPage'
import TestesPage from './pages/TestesPage'
import RelatoriosPage from './pages/RelatoriosPage'
import TurmasPage from './pages/TurmasPage'
import TurmaFormPage from './pages/TurmaFormPage'
import SimuladoPage from './pages/SimuladoPage'
import TesteRunnerPage from './pages/TesteRunnerPage'
import NoticiasPage from './pages/NoticiasPage'
import ProfilePage from './pages/ProfilePage'
import SettingsPage from './pages/SettingsPage'
import LoadingSpinner from './components/shared/LoadingSpinner'
import './index.css'

// Inicializar o handler de erros de autenticação
authUtils.setupAuthErrorHandler()

// Protected Route Wrapper (Simplified as DashboardLayout handles sidebar)
// REMOVED LOCAL DECLARATION TO USE IMPORTED COMPONENT

function App() {
  const { isAuthenticated, profile, loading } = useAuth()

  if (loading) {
    return <LoadingSpinner fullScreen />
  }

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route path="/dashboard" element={
          <ProtectedRoute>
            <DashboardLayout>
              <Dashboard />
            </DashboardLayout>
          </ProtectedRoute>
        } />

        <Route path="/turmas" element={
          <ProtectedRoute requiredRole={['admin', 'professor']}>
            <DashboardLayout>
              <TurmasPage />
            </DashboardLayout>
          </ProtectedRoute>
        } />

        <Route path="/turmas/:id" element={
          <ProtectedRoute requiredRole={['admin', 'professor']}>
            <DashboardLayout>
              <TurmaFormPage />
            </DashboardLayout>
          </ProtectedRoute>
        } />

        <Route path="/users" element={
          <ProtectedRoute requiredRole="admin">
            <DashboardLayout>
              <UsersPage />
            </DashboardLayout>
          </ProtectedRoute>
        } />

        <Route path="/users/new" element={
          <ProtectedRoute requiredRole="admin">
            <DashboardLayout>
              <UserFormPage />
            </DashboardLayout>
          </ProtectedRoute>
        } />

        <Route path="/users/:id/edit" element={
          <ProtectedRoute requiredRole="admin">
            <DashboardLayout>
              <UserFormPage />
            </DashboardLayout>
          </ProtectedRoute>
        } />

        <Route path="/aulas" element={
          <ProtectedRoute requiredRole={['admin', 'professor']}>
            <DashboardLayout>
              <AulasPage />
            </DashboardLayout>
          </ProtectedRoute>
        } />

        <Route path="/questoes" element={
          <ProtectedRoute requiredRole={['admin', 'professor']}>
            <DashboardLayout>
              <QuestoesPage />
            </DashboardLayout>
          </ProtectedRoute>
        } />

        <Route path="/testes" element={
          <ProtectedRoute requiredRole={['admin', 'professor']}>
            <DashboardLayout>
              <TestesPage />
            </DashboardLayout>
          </ProtectedRoute>
        } />

        <Route path="/relatorios" element={
          <ProtectedRoute requiredRole={['admin', 'professor']}>
            <DashboardLayout>
              <RelatoriosPage />
            </DashboardLayout>
          </ProtectedRoute>
        } />

        {/* Rota do simulado - apenas para alunos */}
        <Route path="/simulado" element={
          <ProtectedRoute>
            <DashboardLayout>
              <SimuladoPage />
            </DashboardLayout>
          </ProtectedRoute>
        } />

        {/* Rota de execução de teste específico */}
        <Route path="/teste/:id" element={<TesteRunnerPage />} />

        {/* Rota de notícias - apenas para admins */}
        <Route path="/noticias" element={
          <ProtectedRoute requiredRole={['admin']}>
            <DashboardLayout>
              <NoticiasPage />
            </DashboardLayout>
          </ProtectedRoute>
        } />

        {/* Configurações - apenas para admins */}
        <Route path="/configuracoes" element={
          <ProtectedRoute requiredRole={['admin']}>
            <DashboardLayout>
              <SettingsPage />
            </DashboardLayout>
          </ProtectedRoute>
        } />

        {/* Perfil - para todos os usuários logados */}
        <Route path="/perfil" element={
          <ProtectedRoute>
            <DashboardLayout>
              <ProfilePage />
            </DashboardLayout>
          </ProtectedRoute>
        } />

        {/* Default redirect */}
        <Route
          path="/"
          element={
            isAuthenticated() ? (
              profile?.role === 'aluno' ? <Navigate to="/simulado" replace /> : <Navigate to="/dashboard" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        {/* Rota catch-all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  )
}

export default App